//export  const baseURL =   "https://salmanbitw434.pythonanywhere.com"
//export  const baseURL =   "http://127.0.0.1:5000"
export const baseURL = "https://api.selexsuite.com"
